<loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>
<header class="flex header">
  @if (report != null && report.id) {
    <h2>{{ 'Maintenance_Reports.Forms.Edit' | translate }}</h2>
  } @else {
    <h2>{{ 'Maintenance_Reports.Forms.Create' | translate }}</h2>
  }
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>
<section class="content">
  <form [formGroup]="formGroup">
    <!-- Category -->
    <div class="form-box">
      <label for="assetCategory" class="required">
        {{ 'Maintenance_Reports.Forms.MachineCategory' | translate }}
      </label>
      <p-autocomplete
        fluid
        [formControl]="assetCategory"
        optionLabel="name"
        [dropdown]="true"
        [suggestions]="filteredCategories()"
        (completeMethod)="categoryTypeahead($event)"
        [forceSelection]="true"
        class="w-full"
      />
    </div>
    <!-- Machine -->
    <div class="form-box">
      <label for="assetMachine" class="required">
        {{ 'Maintenance_Reports.Forms.Machine' | translate }}
      </label>
      <p-autocomplete
        fluid
        formControlName="assetId"
        optionLabel="assetId"
        optionValue="assetId"
        [dropdown]="true"
        [suggestions]="filteredAssets()"
        (completeMethod)="assetTypeahead($event)"
        [forceSelection]="true" 
        class="w-full"
      />
    </div>
    <!-- Type -->
    <div class="form-box">
      <label for="type" class="required">
        {{ 'Maintenance_Reports.Forms.Type' | translate }}
      </label>
      <p-autocomplete
        fluid
        formControlName="maintenanceWorkOrderTypeReference"
        optionLabel="name"
        optionValue="id"
        [dropdown]="true"
        [suggestions]="filteredTypes()"
        (completeMethod)="typeTypeahead($event)"
        [forceSelection]="true"
        class="w-full"
      />
    </div>

    <!-- Reason (maintenanceWorkOrderReasonReference) -->
    <div class="form-box">
      <label for="reason" class="required">
        {{ 'Maintenance_Reports.Forms.Reason' | translate }}
      </label>
      <p-autocomplete
        fluid
        formControlName="maintenanceWorkOrderReasonReference"
        optionLabel="name"
        optionValue="id"
        [dropdown]="true"
        [suggestions]="filteredReasons()"
        (completeMethod)="reasonTypeahead($event)"
        [forceSelection]="true"
        class="w-full"
      />
    </div>

    <!-- Is Machine Down -->
    <div class="mb-4">
      <p-checkbox
        inputId="isMachineDown"
        formControlName="isMachineDown"
        binary="true"
      ></p-checkbox>
      <label for="isMachineDown" class="ml-2">
        {{ 'Maintenance_Reports.Forms.IsMachineDown' | translate }}
      </label>
    </div>

    <!-- Submitter Remarks -->
    <div class="form-box">
      <label for="submitterRemarks">
        {{ 'Maintenance_Reports.Forms.Notes' | translate }}
      </label>
      <textarea
        pTextarea
        id="submitterRemarks"
        formControlName="submitterRemarks"
        rows="4"
        placeholder="{{ 'Maintenance_Reports.Forms.AddNote' | translate }}"
        class="w-full"
      ></textarea>
    </div>
  </form>
</section>
<footer>
  <p-button class="w-full" [label]="'Save' | translate" (click)="onSave()" [disabled]="formGroup.invalid" />
  <p-button
    class="w-full"
    [label]="'Cancel' | translate"
    variant="outlined"
    (click)="onClose()"
  />
</footer>
